// Entry point for the shared design-system bundle (gt.js).
//
// Builds to ../web/assets/gt.js + gt.css. Pages opt in with:
//   <link rel="stylesheet" href="/assets/gt.css">
//   <script type="module" src="/assets/gt.js"></script>
// and then use window.GT.* utilities and <gt-*> custom elements. Un-migrated
// pages omit these tags and are unaffected.

import { html } from 'lit';
import './styles/gt.css';
import { fmt } from './fmt.js';
import { chartColors } from './chart.js';
import './components/index.js'; // side-effect: registers <gt-*> elements

const GT = {
  version: '0.1.0',
  fmt,
  chartColors,
  // Lit's html tag, re-exported so plain (non-module) page scripts can build
  // cell templates (with event bindings) for a gt-data-table column `render`.
  html,
};

// Expose on window for the vanilla, non-module page scripts that consume it.
if (typeof window !== 'undefined') {
  window.GT = Object.assign(window.GT || {}, GT);
}

export { fmt, chartColors };
export default GT;
